import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { AnomalyModel } from '../../types/generated.types';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { AnomaliesFilter } from '../../types/anomalies-filter.type';

@Injectable({ providedIn: 'root' })
export class AnomaliesApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/anomalies`;
  }

  async getAnomalies(tenantId: string, pageSize: number, pageIndex: number, filter: AnomaliesFilter): Promise<AnomalyModel[]> {
    const anomalies = await this.get<AnomalyModel[]>(tenantId ?? '', { ...filter, pageSize, pageIndex });
    ApiConversionHelper.convertDates(anomalies, ['started', 'ended']);
    return anomalies;
  }

  async getUnreadCount(tenantId: string): Promise<number> {
    return await this.get<number>(`unread-count${this.getTenantParameter(tenantId)}`);
  }

  async markAsRead(id: string, isRead: boolean): Promise<void> {
    return await this.patch(`${id}/is-read`, isRead);
  }

  async markAllAsRead(tenantId: string): Promise<void> {
    return await this.patch(`all-is-read${this.getTenantParameter(tenantId)}`, null);
  }
}
